define(function() {
  var PixelHelpers = {
    // vars is an obj with keys being names of variables that should be injected.
    // Example key 'subscriber-email'
    // The function will prefix 'sumome-' to the variable name to make sure we don't
    // have conflicts.
    injectVars: function(pixelSnippet, vars) {
      for (var key in vars) {
        if (vars.hasOwnProperty(key)) {
          var regex = new RegExp('\\{\\s*sumome-' + key + '\\s*\\}', 'g')
          pixelSnippet = pixelSnippet.replace(regex, vars[key])
        }
      }
      return pixelSnippet;
    }
  };

  return PixelHelpers;
});
